import { Component } from '@angular/core';

@Component({
  selector: 'lib-certify',
  template: `
    <div class="certify-home">
      <h1>Certify Dashboard</h1>
      <p>Contenido principal de Certify.</p>
    </div>
  `,
  styles: [],
})
export class CertifyComponent {}
